import useId from '../utils/useId';
import * as React from 'react';
export const KNSvg = React.forwardRef(function KNSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement('rect', {
        id: `fi_FlagIcon-KN__a_${id_0}`,
        width: 16,
        height: 12,
        rx: 2,
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('use', {
        fill: '#FCD669',
        xlinkHref: '#fi_FlagIcon-KN__a',
      }),
      /*#__PURE__*/ React.createElement('rect', {
        width: 15,
        height: 11,
        x: 0.5,
        y: 0.5,
        stroke: '#A68527',
        strokeOpacity: 0.1,
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 6V2a1 1 0 0 0-1-1H9V0h5a2 2 0 0 1 2 2v4h-1ZM1 6v4a1 1 0 0 0 1 1h5v1H2a2 2 0 0 1-2-2V6h1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M16 3 3 12H2a2 2 0 0 1-2-2V9l13.5-9h.5a2 2 0 0 1 2 2v1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M2.003 0A2 2 0 0 0 0 2.01V7.5L11.5 0H2.003Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 9.99c0 1.11-.9 2.01-1.992 2.01H5l11-7.5v5.49Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M5 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      }),
    ),
  );
});
KNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KN = {
  category: 'flag',
  colorable: false,
  name: 'KN',
  svg: KNSvg,
};
